import SoupCampaignCollaborativeEditor from './CollaborativeEditor'
export default SoupCampaignCollaborativeEditor
